import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    applicantList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    recruitmentStat: {
        requesting: false,
        error: null,
        success: false,
        data: {
          active_candidates: 0,
          average_time_to_hire: 0,
          offers_extended: 0,
        }
    },
    applicantDetails: {
      requesting: false,
      errors: null,
      success: false,
      data: null,
    },
    pipelineStats: {
      requesting: false,
      errors: null,
      success: false,
      data: null,
    },
    applicantNotes: {
        requesting: false,
        items: [],
        error: null,
        success: false,
    },
    applicantResumePreview: {
      requesting: false,
      errors: null,
      success: false,
      data: null,
    },
  };

export const recruitmentSlice = createSlice({
  name: 'recruitment',
  initialState,
  reducers: {
    getApplicantList: (state, action) => {
        state.applicantList.requesting = true;
        state.applicantList.error = null;
        state.applicantList.items = [];
        state.applicantList.success = false;
        state.applicantList.filters = action.payload;
    },
    getApplicantListSuccess: (state, action) => {
      if(action.payload){
		    const { data, current_page, per_page, total} = action.payload;
        state.applicantList.items = data;
        state.applicantList.pagination.current_page = current_page;
        state.applicantList.pagination.per_page = per_page;
        state.applicantList.pagination.total = total;
      }else{
        state.applicantList.pagination.total = 0;
      }

      state.applicantList.requesting = false; 
      state.applicantList.success = true; 
    },
    getApplicantListFail: (state, action) => {        
        state.applicantList.requesting = false;
        state.applicantList.error = action.payload;
    },

    getRecruitmentStat: (state, action) => {
      state.recruitmentStat.requesting = true;
      state.recruitmentStat.error = null;
      state.recruitmentStat.data = {};
      state.recruitmentStat.success = false;
      state.recruitmentStat.filters = action.payload;
    },
    getRecruitmentStatSuccess: (state, action) => {
      state.recruitmentStat.requesting = false;
      state.recruitmentStat.data = action.payload;
      state.recruitmentStat.success = true; 
    },
    getRecruitmentStatFail: (state, action) => {        
      state.recruitmentStat.requesting = false;
      state.recruitmentStat.error = action.payload;
    },

    getApplicantDetails: (state) => {
        state.applicantDetails.requesting = true;
        state.applicantDetails.errors = null;
        state.applicantDetails.data = null;
        state.applicantDetails.success = false; 
    },
    getApplicantDetailsSuccess: (state, action) => {
        state.applicantDetails.requesting = false;
        state.applicantDetails.data = action.payload;
        state.applicantDetails.success = true; 
    },
    getApplicantDetailsFail: (state, action) => {        
        state.applicantDetails.requesting = false;
        state.applicantDetails.errors = action.payload;
    },

    doAdvanceApplicant: (state) => {
        state.applicantDetails.requesting = true;
        state.applicantDetails.errors = null;
        state.applicantDetails.success = false; 
    },

    doMoveBackApplicant: (state) => {
        state.applicantDetails.requesting = true;
        state.applicantDetails.errors = null;
        state.applicantDetails.success = false; 
    },

    doDeclineApplicant: (state) => {
        state.applicantDetails.requesting = true;
        state.applicantDetails.errors = null;
        state.applicantDetails.success = false; 
    },

    getApplicantScore: (state) => {
        state.applicantList.requesting = true;
        state.applicantList.error = null;
        state.applicantList.success = false;
    },

    getApplicantScoreSuccess: (state, action) => {
        const { data } = action.payload;
        const index = state.applicantList.items.findIndex(
          item => item.jap_id === data.jap_id
        );

        if (index !== -1) {
          state.applicantList.items[index] = {
              ...state.applicantList.items[index],
              ...data
          };
      }
    },

    getApplicantScoreFail: (state, action) => {
        state.applicantDetails.requesting = false;
        state.applicantDetails.errors = action.payload;
    },

    getPipelineStats: (state) => {
        state.pipelineStats.requesting = true;
        state.pipelineStats.errors = null;
        state.pipelineStats.data = null;
        state.pipelineStats.success = false; 
    },
    getPipelineStatsSuccess: (state, action) => {
        state.pipelineStats.requesting = false;
        state.pipelineStats.data = action.payload;
        state.pipelineStats.success = true; 
    },
    getPipelineStatsFail: (state, action) => {        
        state.pipelineStats.requesting = false;
        state.pipelineStats.errors = action.payload;
    },

    getApplicantNotes: (state) => {
        state.applicantNotes.requesting = true;
        state.applicantNotes.error = null;
        state.applicantNotes.items = [];
        state.applicantNotes.success = false; 
    },
    getApplicantNotesSuccess: (state, action) => {
        state.applicantNotes.requesting = false;
        state.applicantNotes.items = action.payload;
        state.applicantNotes.success = true; 
    },
    getApplicantNotesFail: (state, action) => {        
        state.applicantNotes.requesting = false;
        state.applicantNotes.error = action.payload;
    },
    doAddApplicantNotes: (state) => {
        state.applicantNotes.requesting = true;
        state.applicantNotes.error = null;
        state.applicantNotes.items = [];
        state.applicantNotes.success = false; 
    },
    doAddApplicantNotesSuccess: (state, action) => {
        state.applicantNotes.requesting = false;
        state.applicantNotes.items = [...state.applicantNotes.items, action.payload];
        state.applicantNotes.success = true; 
    },
    doAddApplicantNotesFail: (state, action) => {        
        state.applicantNotes.requesting = false;
        state.applicantNotes.error = action.payload;
    },

    getApplicantResumePreview: (state) => {
        state.applicantResumePreview.requesting = true;
        state.applicantResumePreview.errors = null;
        state.applicantResumePreview.data = null;
        state.applicantResumePreview.success = false; 
    },
    getApplicantResumePreviewSuccess: (state, action) => {
        state.applicantResumePreview.requesting = false;
        state.applicantResumePreview.data = action.payload;
        state.applicantResumePreview.success = true; 
    },
    getApplicantResumePreviewFail: (state, action) => {        
        state.applicantResumePreview.requesting = false;
        state.applicantResumePreview.errors = action.payload;
    },

    doSaveApplicantResumePreview: (state) => {
        state.applicantResumePreview.requesting = true;
        state.applicantResumePreview.errors = null;
        state.applicantResumePreview.success = false; 
    },
    
  },
})

export const { 
    getApplicantList, getApplicantListSuccess, getApplicantListFail,
    getRecruitmentStat, getRecruitmentStatSuccess, getRecruitmentStatFail,
    getApplicantDetails, getApplicantDetailsSuccess, getApplicantDetailsFail,
    doAdvanceApplicant, doDeclineApplicant, doMoveBackApplicant,
    getApplicantScore, getApplicantScoreSuccess, getApplicantScoreFail,
    getPipelineStats, getPipelineStatsSuccess, getPipelineStatsFail,
    getApplicantNotes, getApplicantNotesSuccess, getApplicantNotesFail,
    doAddApplicantNotes, doAddApplicantNotesSuccess, doAddApplicantNotesFail,
    getApplicantResumePreview, getApplicantResumePreviewSuccess, getApplicantResumePreviewFail,
    doSaveApplicantResumePreview,
} = recruitmentSlice.actions

export default recruitmentSlice.reducer